import { useSelector } from 'react-redux';

import { hasAnyPermission } from '@f/services/authentication/authentication.selectors';

export function useCheckPermissions() {
  return useSelector((state: any) => (permissions: string[]) => hasAnyPermission(state, permissions));
}
